import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Theme } from '@domgen/dgx-fe-common';
import { ButtonComponent } from '@domgen/dgx-fe-components/button';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { PictureComponent } from '@domgen/dgx-fe-components/media';
import {
  PanelBorderRadius,
  PanelComponent,
} from '@domgen/dgx-fe-components/panel';
import {
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { RegistrationCPGResponse } from '@us-registration/util-models';
import { translation } from '../../i18n/translation.constant';

@Component({
  selector: 'us-registration-confirmation-cpg-panel',
  standalone: true,
  imports: [
    ButtonComponent,
    IconComponent,
    NgIf,
    PanelComponent,
    PictureComponent,
    TranslatePipe,
  ],
  templateUrl: './registration-confirmation-cpg-panel.component.html',
  styleUrls: ['./registration-confirmation-cpg-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegistrationConfirmationCPGPanelComponent {
  @Input() applianceCPG!: RegistrationCPGResponse;
  @Input() variant: Theme = 'background';
  @Input() border = false;
  @Input() rounded?: PanelBorderRadius = 'lg';

  codeCopied = false;

  copyPromoCode() {
    navigator.clipboard.writeText(this.applianceCPG.promoCode);
    this.codeCopied = true;
  }
}
